import "./AboutUs.module.css";
import Header from "@/reusable_sections/Header";
import OurStoryVision from "./sections/OurStoryVision";
import OurCoreValues from "./sections/OurCoreValues";
import Footer from "@/reusable_sections/Footer";
export default function AboutUsPage() {
  return <div>
      <Header />
      <OurStoryVision />
      <OurCoreValues />
      <Footer />
    </div>;
}